export default "/assets/envelope-8d0d7c8003f3ee3012db6b1a588ff802e7e3f00726be24ca7aeb7ffc5babfa9d.svg";